import React from 'react';
import { fmtMoney } from './vigilanciaUtils';

const R = 34;
const C = 2 * Math.PI * R;

export const LimiteGauge = ({ label, consumido, limite, restante, pct, alerta, testid }) => {
  const sinDato = consumido === undefined || consumido === null;
  const p = Math.min(Math.max(Number(pct) || 0, 0), 100);
  const color = alerta ? '#e11d48' : p >= 70 ? '#d97706' : '#0f766e';
  return (
    <div className="flex items-center gap-4 rounded-xl bg-slate-50/80 border border-slate-100 p-3" data-testid={testid}>
      <div className="relative h-[76px] w-[76px] shrink-0">
        <svg viewBox="0 0 80 80" className="h-full w-full -rotate-90">
          <circle cx="40" cy="40" r={R} stroke="#e2e8f0" strokeWidth="8" fill="none" />
          <circle
            cx="40" cy="40" r={R} stroke={color} strokeWidth="8" fill="none" strokeLinecap="round"
            strokeDasharray={C} strokeDashoffset={C * (1 - (sinDato ? 0 : p) / 100)}
            style={{ transition: 'stroke-dashoffset 800ms cubic-bezier(.2,.8,.2,1), stroke 300ms' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-[15px] font-bold tabular-nums leading-none" style={{ color }}>
            {sinDato ? '—' : `${p.toFixed(0)}%`}
          </span>
          <span className="mt-0.5 text-[9px] uppercase tracking-[0.12em] text-slate-400">usado</span>
        </div>
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">{label}</p>
        <p className="mt-0.5 text-lg font-bold tabular-nums text-slate-900 truncate" data-testid={`${testid}-restante`}>
          {sinDato ? '—' : fmtMoney(restante)}
        </p>
        <p className="text-[11px] text-slate-400 -mt-0.5">disponible del límite</p>
        <p className="mt-1 text-xs text-slate-600 tabular-nums truncate" data-testid={`${testid}-consumido`}>
          <span className="font-semibold" style={{ color }}>{sinDato ? '—' : fmtMoney(consumido)}</span>
          <span className="text-slate-400"> de {fmtMoney(limite)}</span>
        </p>
      </div>
    </div>
  );
};

export default LimiteGauge;
